module.exports = __webpack_public_path__ + "img/slide_p4.31142c2e.png";